import { COMMON_CHUNK_NAME } from '../../../../../const/generator';
import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IParseResult,
} from '../../../../../types';
import { getSlotRelativePath } from '../../../../../utils/pathHelper';

export type GantConfigPluginConfig = {
  route: any[];
  /**包 */
  packageName?: string;
  /** 版本 */
  packageVersion?: string;
};

const pluginFactory: BuilderComponentPluginFactory<GantConfigPluginConfig> = (cfg) => {
  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IParseResult;

    const rootPath = getSlotRelativePath({
      contextData: next.contextData,
      from: 'config',
      to: 'pages',
    });
    const routeList = ir.globalRouter?.routes || [];

    // 对于 path 末尾是 index 的路由，用 fileName 去掉末尾 /index 后从最后一级开始取，
    // 若有重复则往前多取一级，直到全部唯一
    const needsFileNamePath = (route: (typeof routeList)[0]) => {
      const rawPath = route.path.replace(/\/index$/, '') || route.path;
      return rawPath === 'index' || rawPath === '/index';
    };

    // 计算每条路由的 fileNameBase（去掉末尾 /index）
    const fileNameBases = routeList.map((route) => (route.fileName || '').replace(/\/index$/, ''));

    // 只对需要用 fileName 推导 path 的条目做去重深度计算
    const depths = routeList.map(() => 1);
    let hasConflict = true;
    while (hasConflict) {
      hasConflict = false;
      const segMap = new Map<string, number[]>();
      routeList.forEach((route, i) => {
        if (!needsFileNamePath(route)) return;
        const parts = fileNameBases[i].split('/');
        const seg = parts.slice(Math.max(0, parts.length - depths[i])).join('/');
        if (!segMap.has(seg)) segMap.set(seg, []);
        segMap.get(seg)!.push(i);
      });
      const conflictGroups = Array.from(segMap.values()).filter((indices) => indices.length > 1);
      for (const indices of conflictGroups) {
        for (const i of indices) {
          const maxDepth = fileNameBases[i].split('/').length;
          if (depths[i] < maxDepth) {
            depths[i]++;
            hasConflict = true;
          }
        }
      }
    }

    const routes = routeList.map((route, i) => {
      let pathSegment: string;
      if (needsFileNamePath(route)) {
        // 用 fileName 推导：取去掉 /index 后从末尾数 depths[i] 级
        const parts = fileNameBases[i].split('/');
        pathSegment = parts.slice(Math.max(0, parts.length - depths[i])).join('/');
      } else {
        pathSegment = route.path.replace(/\/index$/, '') || route.path;
      }

      // component 去掉末尾 /index，框架会自动解析
      const componentName = route.componentName.replace(/\/index$/, '');
      const component = `@lowcode/${rootPath}${componentName}`.replace(/^@lowcode\/\.\//, '@lowcode/');

      return {
        path: `/**/${pathSegment}`,
        title: route.title || pathSegment,
        component,
        exact: true,
      };
    });

    const configContent = `export default {
  resolve: {
    alias: {
      '@lowcode': __dirname,
    },
  },
  routes: ${JSON.stringify(routes, null, 4)
    .replace(/"(@lowcode\/[^"]+)"/g, "'$1'")
    .replace(/"(\*\*\/[^"]+)"/g, "'$1'")},
};
`;

    next.chunks.push({
      type: ChunkType.STRING,
      fileType: FileType.TS,
      name: COMMON_CHUNK_NAME.FileMainContent,
      content: configContent,
      linkAfter: [],
    });

    return next;
  };
  return plugin;
};

export default pluginFactory;
